module.exports = __webpack_public_path__ + "static/media/single_column_white.79e49da4.svg";